module.exports = __webpack_public_path__ + "static/media/da-DK.03197df3.md";